import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import MetisMenu from 'metismenujs';
import './App.css';
import { useAuth } from './context/AuthContext';
import withPermission from './utils/withPermission';
function Sidebar() {
  const { permissions, moduleNames } = useAuth();
  const WithListPermission = withPermission(({ children }) => children, ['instance-list']);
  const WithRolePermission = withPermission(({ children }) => children, ['role-list']);
  const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
  const WithProductPermission = withPermission(({ children }) => children, ['product-list']);
  const WithBrandPermission = withPermission(({ children }) => children, ['brand-list']);
  const WithClientPermission = withPermission(({ children }) => children, ['client-list']);
  const WithOrgPermission = withPermission(({ children }) => children, ['organisation-list']);
  const WithIndPermission = withPermission(({ children }) => children, ['industry-list']);
  const WithCatPermission = withPermission(({ children }) => children, ['category-list']);
  const WithLICPermission = withPermission(({ children }) => children, ['licensetype-list']);
  const WithAMCPermission = withPermission(({ children }) => children, ['amcsetting-list']);
  const WithCountryPermission = withPermission(({ children }) => children, ['country-list']);
  const WithUserPermission = withPermission(({ children }) => children, ['user-list']);
  const WithPerPermission = withPermission(({ children }) => children, ['permission-list']);
  const WithVendorPermission = withPermission(({ children }) => children, ['vendor-list']);
  const WithTenantPermission = withPermission(({ children }) => children, ['tenant-list']);
  const WithLeadPermission = withPermission(({ children }) => children, ['lead-list']);
  const WithDealPermission = withPermission(({ children }) => children, ['deal-list']);
  const WithOrderPermission = withPermission(({ children }) => children, ['order-list']);

  const WithProPermission = withPermission(({ children }) => children, ['proformainvoice-list']);
  const WithSettingermission = withPermission(({ children }) => children, ['setting-edit']);
  const WithExpenseTypePermission = withPermission(({ children }) => children, ['expensetype-list']);
  const WithExpensePermission = withPermission(({ children }) => children, ['expense-list']);
  const WithBankPermission = withPermission(({ children }) => children, ['bankaccount-list']);
  const WithTransPermission = withPermission(({ children }) => children, ['transaction-list']);
  const WithsysPermission = withPermission(({ children }) => children, ['systemtenant-list']);
  const WithContacttypePermission = withPermission(({ children }) => children, ['contacttype-list']);
  const WithMDPermission = withPermission(({ children }) => children, ['dashboard-main']);
  const WithSDPermission = withPermission(({ children }) => children, ['dashboard-sales']);
  const WithADPermission = withPermission(({ children }) => children, ['dashboard-account']);
  const WithODPermission = withPermission(({ children }) => children, ['dashboard-operation']);
  const WithEmployeePermission = withPermission(({ children }) => children, ['employee-list']);
  const WithAllowancePermission = withPermission(({ children }) => children, ['allowance-list']);
  const WithAttendancePermission = withPermission(({ children }) => children, ['attendance-list']);
  const WithLeaveTypePermission = withPermission(({ children }) => children, ['leavetype-list']);
  const WithLeaveEntitlementPermission = withPermission(({ children }) => children, ['leave-list']);
  const WithLeaveApplyPermission = withPermission(({ children }) => children, ['leaveapply-list']);
  const WithHolidayPermission = withPermission(({ children }) => children, ['holiday-list']);
  const WithPrefixPermission = withPermission(({ children }) => children, ['prefix-list']);
  const WithEventPermission = withPermission(({ children }) => children, ['event-list']);
  const WithLoanPermission = withPermission(({ children }) => children, ['loan-list']);
  const WithDeductionPermission = withPermission(({ children }) => children, ['deduction-list']);
  const WithOverPermission = withPermission(({ children }) => children, ['overtime-list']);
  const WithOverTypePermission = withPermission(({ children }) => children, ['overtimetype-list']);
  const WithOvApprovalPermission = withPermission(({ children }) => children, ['overtime-approve']);
  const WithLoanApprovalPermission = withPermission(({ children }) => children, ['loan-approve']);
  const WithProductPricingPermission = withPermission(({ children }) => children, ['productpricing-list']);
  const WithFinancialLockPermission = withPermission(({ children }) => children, ['lock-list']);
  const WithActivityTypePermission = withPermission(({ children }) => children, ['activitytype-list']);

















  // // const canList = permissions.includes('industry-list');
  // useEffect(() => {
  //   const menu = new MetisMenu('#side-menu'); // Initialize MetisMenu
  //   return () => {
  //     menu.dispose(); // Clean up to avoid memory leaks
  //   };
  // }, []);
  const menuRef = useRef(null);
  const metisMenuInstance = useRef(null);
  useEffect(() => {
    if (menuRef.current) {
      metisMenuInstance.current = new MetisMenu(menuRef.current);
    }

    return () => {
      // Ensure MetisMenu is initialized before disposing it
      if (metisMenuInstance.current && menuRef.current) {
        try {
          metisMenuInstance.current.dispose(); // Dispose safely
        } catch (error) {
          console.error("Error disposing MetisMenu:", error);
        }
        metisMenuInstance.current = null;
      }
    };
  }, []);
  const hasAnyPermission = (requiredPermissions = []) => {
    return requiredPermissions.some(permission => permissions.includes(permission));
  };
  return (
    <div className="vertical-menu">
      <div data-simplebar className="h-100">
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu" ref={menuRef}>
            {moduleNames.includes("Dashboard") && (
              <li>
                <a href="#" className="has-arrow waves-effect">
                  <i className="bx bx-home-circle" />
                  <span>Dashboards</span>
                </a>
                <ul className="sub-menu" aria-expanded="false">
                  <li> <WithMDPermission><Link to="/dashboard">Main Dashboard</Link></WithMDPermission></li>
                  <li> <WithSDPermission><Link to="/sales-dashboard">Sales Dashboard</Link></WithSDPermission></li>
                  <li> <WithADPermission><Link to="/account-dashboard">Account Dashboard</Link></WithADPermission></li>
                  <li> <WithODPermission><Link to="/operation-dashboard">Operation Dashboard</Link></WithODPermission></li>

                </ul>
              </li>
            )}

            {moduleNames.includes("Sales") && (
              <li>
                <a href="#" className="has-arrow waves-effect">
                  <i className="bx bxs-wallet-alt" />
                  <span>Sales</span>

                </a>
                <ul className="sub-menu" aria-expanded="false">
                  <li> <WithOrgPermission><Link to="/organisation">Organisation</Link></WithOrgPermission></li>
                  <li> <WithLeadPermission><Link to="/lead">Lead</Link></WithLeadPermission></li>
                  <li> <WithDealPermission><Link to="/deal">Opportunity</Link></WithDealPermission>
                  </li>
                  <li><WithOrderPermission><Link to="/orders">Sales Order</Link></WithOrderPermission></li>
                  <li>
                    <WithClientPermission><Link to="/client?sales=true">Nurture</Link></WithClientPermission>
                  </li>
                  {/* <li> <WithPartnerPermission><Link to="/partner">Partner</Link></WithPartnerPermission></li> */}

                </ul>
              </li>
            )}
            {moduleNames.includes("Operation") && (
              <li>
                <a href="#" className="has-arrow waves-effect">
                  <i className="bx bxs-user-detail" />
                  <span>Operation</span>

                </a>
                <ul className="sub-menu" aria-expanded="false">
                  <li> <WithClientPermission><Link to="/client">Client</Link></WithClientPermission></li>
                  <li><WithVendorPermission><Link to="/vendor">Vendor</Link></WithVendorPermission></li>
                  <li><WithOrderPermission><Link to="/orders">Sales Order</Link></WithOrderPermission></li>
                  <li><WithProPermission><Link to="/invoices">Invoice</Link></WithProPermission></li>
                  <li><WithExpensePermission><Link to="/expenses">Journal Entry</Link></WithExpensePermission></li>
                  <li><Link to='/quotation-list'>Quotation</Link></li>
                  <li><Link to='/po-list'>Purchase Order</Link></li>
                  <li><Link to='/import-export-data'>Data Upload</Link></li>





                </ul>
              </li>
            )}
            {moduleNames.includes("License Management") && (
              <li>
                <a href="#" className="has-arrow waves-effect">
                  <i className="bx bx-briefcase-alt-2" />
                  <span>License Management</span>
                </a>
                <ul className="sub-menu" aria-expanded="false">
                  <li><WithTenantPermission><Link to="/tenants">Tenants</Link></WithTenantPermission></li>
                                    <li><WithListPermission><Link to="/instance">Instance</Link></WithListPermission></li>

                  <li><Link to="/license-types">License Types</Link></li>

                  <li> <WithIndPermission><Link to="/industries">Industry</Link></WithIndPermission></li>


                </ul>
              </li>
            )}
            {moduleNames.includes("Product") && (
              <li>
                <a href="#" className="has-arrow waves-effect">
                  <i className="bx bx-store" />
                  <span>Product</span>

                </a>
                <ul className="sub-menu" aria-expanded="false">
                  <li> <WithProductPermission><Link to="/product">Product</Link></WithProductPermission></li>
                  {/* <li> <WithProductPricingPermission><Link to="/product-pricing">Pricing</Link></WithProductPricingPermission></li> */}
                  <li> <WithLICPermission><Link to="/categories?type=product">Type</Link></WithLICPermission></li>
                  <li> <WithBrandPermission><Link to="/brands">Brand</Link></WithBrandPermission></li>
                  <li><WithAMCPermission><Link to="/amc-setting">AMC Type</Link></WithAMCPermission></li>



                </ul>
              </li>
            )}
            {moduleNames.includes("Account") && (
              <li>

                <a href="#" className="has-arrow waves-effect">
                  <i className="bx bxs-dollar-circle" />
                  <span>Account</span>
                </a>
                <ul className="sub-menu" aria-expanded="false">
                  <li><WithTransPermission><Link to="/transactions">Transaction</Link></WithTransPermission></li>
                  <li><Link to="/bank-details">Account Summary</Link></li>
                  <li><WithBankPermission><Link to="/bank-accounts">Account</Link></WithBankPermission></li>
                  <li><Link to='/payroll-providers'>Payroll Provider</Link></li>
                  <li><Link to='/vat-return'>VAT Returns</Link></li>

                  <li><WithExpenseTypePermission>
                    <Link to="/expense-type">Expense Type</Link></WithExpenseTypePermission></li>
                  <li><WithCatPermission>
                    <Link to="/categories?type=expense">Category</Link></WithCatPermission></li>


                  {/* <li><Link to="/tax">Tax</Link></li> */}




                </ul>
              </li>
            )}
            {moduleNames.includes("Reports") && (
              <li>


                <a href="#" className="has-arrow waves-effect">
                  <i className="bx bx-file" />
                  <span>Reports</span>
                </a>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/chart-of-accounts">Chart of Accounts</Link></li>
                  <li>
                    <Link to="/balancesheet">Balance Sheet</Link></li>
                  <li>
                    <Link to="/profitandloss">Profit & Loss</Link></li>
                  <li><Link to="/trialbalance">Trial Balance</Link></li>
                  <li><Link to="/ledgerstatement">Ledger Statements</Link></li>
                  <li><Link to="/bank-reconciliation-report">Bank Reconciliation Report</Link></li>

                  <li><Link to="/cashflow-statement">Cashflow Statements</Link></li>

                  <li><Link to="/statement-of-accounts">Statement Of Account</Link></li>

                  <li><Link to="/partner-soa">Partner SOA</Link></li>

                  <li><Link to="/receivable-report">Customer Receipts Reconciliation</Link></li>
                  <li><Link to="/receivable-aging-report">Account Receivable Aging </Link></li>
                  <li><Link to="/payable-aging-report">Account Payable Aging </Link></li>
                  <li><Link to="/expense-report">Expense Report</Link></li>

                  <li><Link to="/tax">VAT Report</Link></li>
                  <li><Link to="/revenue-list">Revenue Recognition</Link></li>
                  <li><Link to="/revenue-report">Revenue Report</Link></li>
                  <li><Link to="/expense-recognition">Expense Recognition</Link></li>









                </ul>
              </li>
            )}
            {/* {moduleNames.includes("HR") && (
              <li>
                <a href="#" className="has-arrow waves-effect">

                  <i className="bx bx-user-check" />

                  <span>HR</span>
                </a>
                <ul className="sub-menu" aria-expanded="false">
                  <li><WithEmployeePermission>
                    <Link to="/employee">Employee Management</Link></WithEmployeePermission></li>
                  <li><WithAllowancePermission><Link to="/allowance">Allowance</Link></WithAllowancePermission></li>
                  <li><WithAttendancePermission><Link to="/attendance">Attendance</Link></WithAttendancePermission></li>
                  <li><WithLeaveTypePermission><Link to="/leave-type">Leave Type</Link></WithLeaveTypePermission></li>
                  <li><WithLeaveEntitlementPermission><Link to="/leave-entitlement">Leave Define</Link></WithLeaveEntitlementPermission></li>
                  <li><WithLeaveApplyPermission><Link to="/leave-application">Leave Application</Link></WithLeaveApplyPermission></li>
                  <li><Link to="/pending-leave">Pending Leave</Link></li>
                  <li><WithHolidayPermission><Link to="/holiday-list">Holiday Setup</Link></WithHolidayPermission></li>
                  <li><WithEventPermission><Link to="/employee-event">Event</Link></WithEventPermission></li>



                </ul>

              </li>

            )} */}
            {moduleNames.includes("HR") && (
              <li>
                <a href="#" className="has-arrow waves-effect">
                  <i className="bx bx-user-check" />
                  <span>HR</span>
                </a>
                <ul className="sub-menu" aria-expanded="false">

                  <li>
                    <WithEmployeePermission>
                      <Link to="/employee">Employee Management</Link>
                    </WithEmployeePermission>
                  </li>

                  <li>
                    <WithAllowancePermission>
                      <Link to="/allowance">Allowance</Link>
                    </WithAllowancePermission>
                  </li>

                  {/* Attendance Parent Menu */}
                  <li>
                    <a href="#" className="has-arrow">Attendance</a>
                    <ul className="sub-menu" aria-expanded="false">
                      <li>
                        <WithAttendancePermission>
                          <Link to="/attendance">Attendance List</Link>
                        </WithAttendancePermission>
                      </li>
                      {/* <li>
                        <Link to="/attendance-report">Attendance Report</Link>
                      </li> */}
                    </ul>
                  </li>

                  {/* Leave Parent Menu */}
                  {/* Leave Parent Menu */}
                  <li>
                    <a href="#" className="has-arrow waves-effect">
                      <span>Leave</span>
                    </a>
                    <ul className="sub-menu" aria-expanded="false">
                      <li>
                        <WithLeaveTypePermission>
                          <Link to="/leave-type">Leave Type</Link>
                        </WithLeaveTypePermission>
                      </li>
                      <li>
                        <WithLeaveEntitlementPermission>
                          <Link to="/leave-entitlement">Leave Define</Link>
                        </WithLeaveEntitlementPermission>
                      </li>
                      <li>
                        <WithLeaveApplyPermission>
                          <Link to="/leave-application">Leave Application</Link>
                        </WithLeaveApplyPermission>
                      </li>
                      <li>
                        <Link to="/pending-leave">Pending Leave</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a href="#" className="has-arrow waves-effect">
                      <span>Loan</span>
                    </a>
                    <ul className="sub-menu" aria-expanded="false">
                      <li>
                        <WithLoanPermission>
                          <Link to="/loan">Loan Apply</Link>
                        </WithLoanPermission>
                      </li>
                      <li><WithLoanApprovalPermission>
                        <Link to="/loan-approval">Loan Approval</Link>
                      </WithLoanApprovalPermission>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <WithDeductionPermission>
                      <Link to="/deductions">Deduction</Link>
                    </WithDeductionPermission>
                  </li>
                  {/* <li>
                    <WithOverPermission>
                      <Link to="/overtimes">Overtime</Link>
                    </WithOverPermission>
                  </li> */}
                  <li>
                    <a href="#" className="has-arrow waves-effect">
                      <span>Overtime</span>
                    </a>
                    <ul className="sub-menu" aria-expanded="false">
                      <li>
                        <WithOverTypePermission>
                          <Link to="/overtime-types">Overtime Types</Link>
                        </WithOverTypePermission>
                      </li>
                      <li>
                        <WithOverPermission>
                          <Link to="/overtimes">Overtime Request</Link>
                        </WithOverPermission>
                      </li>
                      <li><WithOvApprovalPermission>
                        <Link to="/overtime-approval">Overtime Approval</Link>
                      </WithOvApprovalPermission></li>
                    </ul>
                  </li>
                  <li>
                    <Link to="/payroll">Payroll</Link>
                  </li>

                  <li>
                    <WithHolidayPermission>
                      <Link to="/holiday-list">Holiday Setup</Link>
                    </WithHolidayPermission>
                  </li>

                  <li>
                    <WithEventPermission>
                      <Link to="/employee-event">Event</Link>
                    </WithEventPermission>
                  </li>

                </ul>
              </li>
            )}

            {moduleNames.includes("Contact") && (
              <li>
                <a href="#" className="has-arrow waves-effect">

                  <i className="bx bx-user-circle" />

                  <span>Contact</span>
                </a>
                <ul className="sub-menu" aria-expanded="false">
                  <li><WithContactPermission>
                    <Link to="/contacts">Contact</Link></WithContactPermission></li>
                  <li><WithContacttypePermission><Link to="/contact-type">Types</Link></WithContacttypePermission></li>



                </ul>

              </li>

            )}
            {moduleNames.includes("User Manager") && (
              <li>

                <a href="#" className="has-arrow waves-effect">
                  <i className="bx bx-user" />
                  <span>User Manager</span>
                </a>
                <ul className="sub-menu" aria-expanded="false">
                  <li><WithUserPermission>
                    <Link to="/user">Users</Link></WithUserPermission></li>

                  <li><WithRolePermission><Link to="/roles">Role</Link></WithRolePermission></li>
                  <li><WithPerPermission><Link to="/permission">Permission</Link></WithPerPermission></li>



                </ul>
              </li>
            )}
            {moduleNames.includes("Setting") && (

              <li>
                <a href="#" className="has-arrow waves-effect">
                  <i className="bx bx-cog" />
                  <span>Setings</span>
                </a>
                <ul className="sub-menu" aria-expanded="false">
                  <li> <WithSettingermission><Link to="/settings">Settings</Link></WithSettingermission></li>
                  <li> <Link to="/activity-logs">Activity Logs</Link></li>


                  <li><WithCountryPermission><Link to="/countries">Country</Link></WithCountryPermission></li>
                  <li><WithsysPermission><Link to="/systemtenant">Tenant</Link></WithsysPermission></li>
                  <li><WithPrefixPermission><Link to="/prefix">Prefix</Link></WithPrefixPermission></li>
                  <li><WithFinancialLockPermission><Link to="/financial-lock">Financial Lock</Link></WithFinancialLockPermission></li>
                  <li><WithActivityTypePermission><Link to="/activity-type">Activity Types</Link></WithActivityTypePermission></li>

                </ul>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;






